import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

// find all plugin target elements
const pluginElements: HTMLElement[] = Array.from(
  document.querySelectorAll<HTMLElement>('[data-club-plugin]') // look for data attribute
);

// if none found, fallback to default ID
if (pluginElements.length === 0) {
  const defaultEl = document.getElementById('simplex-club-plugin');
  if (defaultEl) pluginElements.push(defaultEl);
}

// render a separate React root for each element
pluginElements.forEach((el: HTMLElement, idx: number) => {
  const root = ReactDOM.createRoot(el);
  root.render(
    <React.StrictMode>
      <App
        element={el}
        idx={idx}
      />
    </React.StrictMode>
  );
});
